'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroModal = require('./NitroModal');

var _NitroModal2 = _interopRequireDefault(_NitroModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroModal2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-modal/index.js
// module id = 92
// module chunks = 4